import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import '../../forecast/styles/styles.css';
import { MotifPaginationSelect, MotifPaginationSelectItem, MotifTable } from '@ey-xd/motif-react'; //import moitif related libs

import { MotifChip } from '@ey-xd/motif-react';

import {
  EmptyForcastContainer,
  EmptyForcastText,
  TableData1C,
  TableData1CBold,
  PLPastStatusCell,
  PLPastTableContainer,
} from '../../../../atoms/tableData/styles/tableData.styles'; //import table cells
import {
  pastMonthlyopportunitiesPL,
  pastQuaterlyopportunitiesPL,
  getOpportunitiesDetails,
  getQuaterlyDetails,
} from '../../../../../services/pursuitLeaderServices'; //setup api call from here
import TableHeader from '../../../../molecules/dcsp/components/tableHeader';
import SpinnerLoader from '../../../../atoms/SpinnerLoader';
import {
  DateSorting,
  DateFiltering,
  filterOpportunityById,
  OppsNameSorting,
} from '../../../../../util/commonFunctions';

import wonIcon from '../../../../assets/icons/medal.png';
import openIcon from '../../../../assets/icons/dashed_circle.png';
import lostIcon from '../../../../assets/icons/block_circle.png';

import {
  QUARTERLY_DETAILS,
  TABLE_HEADER_SUBTEXT,
  abbreviatedMonthList,
} from '../../../../../constants/commonConstants';
import { isMobile } from 'react-device-detect';

let gridApi;

const PursuitLeaderPastTable = props => {
  const [isLoading, setIsLoading] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [opportunitiesLoaded, setOpportunitiesLoaded] = useState(false);
  const [showEmptyForecast, setShowEmptyForecast] = useState(false);
  const [totalPageRows, setTotalPageRows] = useState('12');
  let forecast_type = props.forecast_type;
  let EMAIL = props.email;
  let MONTH = props.month;
  let QUARTER = props.quarter;
  let YEAR = props.year;
  let rowDataArray;

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        let getOpportunitiesDetailsAPI = await (forecast_type === 'month'
          ? pastMonthlyopportunitiesPL(EMAIL, YEAR, QUARTER, MONTH)
          : forecast_type === 'quarter'
            ? pastQuaterlyopportunitiesPL(EMAIL, YEAR, QUARTER)
            : Promise.reject(new Error('Invalid forecast_type')));

        rowDataArray = getOpportunitiesDetailsAPI.opportunities;
        setRowData(getOpportunitiesDetailsAPI.opportunities);

        setTimeout(() => {
          const availableTableHeight = document.getElementById('container')?.clientHeight;
          const rowCount = availableTableHeight && calculatePageSize(availableTableHeight);
          setTotalPageRows(rowCount);
        }, 500);
      } catch (error) {
        console.error('Error:', error);
      } finally {
        const timeoutId = setTimeout(() => {
          setIsLoading(false);
        }, 2000);
        return () => clearTimeout(timeoutId);
      }
    };

    fetchData();
  }, [forecast_type, EMAIL, YEAR, QUARTER, MONTH]);

  const calculatePageSize = tableHeight => {
    const screenHeight = window.innerHeight;
    const singleRowHeight = 43; //(in Pixel)
    let minusFactor = screenHeight <= 720 ? 1 : 2;
    const totalRows = Math.floor(tableHeight / singleRowHeight) - minusFactor;
    return JSON.stringify(totalRows);
  };

  const handleGridReady = params => {
    ({ api: gridApi } = params);
  };

  const TextCellRendererC = ({ value }) => <TableData1C>{value}</TableData1C>;
  TextCellRendererC.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const TextCellRendererCBold = ({ value }) => <TableData1CBold>{value}</TableData1CBold>;

  const CommitCellRenderer = ({ value }) => (
    <MotifChip
      variant={value == 0 ? 'disabled' : value == 1 ? 'success' : value == -1 ? 'error' : ''}
      type="dot"
    >
      {value == 0
        ? QUARTERLY_DETAILS.NOT_COMMITTED
        : value == 1
          ? QUARTERLY_DETAILS.COMMITTED
          : value == -1
            ? QUARTERLY_DETAILS.MISSED
            : ''}
    </MotifChip>
  );

  const StatusCellRenderer = ({ value }) => {
    if (value === 'open') {
      return (
        <div>
          <PLPastStatusCell>
            <img src={openIcon} />
            <TableData1C>{QUARTERLY_DETAILS.OPEN}</TableData1C>
          </PLPastStatusCell>
        </div>
      );
    } else if (value === 'won') {
      return (
        <div>
          <PLPastStatusCell>
            <img src={wonIcon} width={16} height={16} />
            <TableData1C>{QUARTERLY_DETAILS.WON}</TableData1C>
          </PLPastStatusCell>
        </div>
      );
    } else if (value === 'declined') {
      return (
        <div>
          <PLPastStatusCell>
            <img src={lostIcon} width={16} height={16} />
            <TableData1C>{QUARTERLY_DETAILS.DECLINED}</TableData1C>
          </PLPastStatusCell>
        </div>
      );
    } else {
      return (
        <div>
          <PLPastStatusCell>
            <img src={lostIcon} />
            <TableData1C>{QUARTERLY_DETAILS.LOST}</TableData1C>
          </PLPastStatusCell>
        </div>
      );
    }
  };

  const DateCellRenderer = props => {
    const date = props.date;
    const month = props.month;
    if (date === null) {
      return <TableData1C>-</TableData1C>;
    } else {
      const month_array = abbreviatedMonthList;
      let isoDate = new Date(date);
      let derivedMonth = month_array[isoDate.getMonth()];
      let derivedDate = isoDate.getDate();
      let derivedYear = isoDate.getFullYear();
      if (derivedDate < 10) {
        derivedDate = `0${derivedDate}`;
      }
      let final_date = `${derivedDate} ${derivedMonth} ${derivedYear} (${month})`;
      return <TableData1C>{final_date}</TableData1C>;
    }
  };

  const TextCellRendererD = props => {
    const commit_tov = props.commit_tov;
    const sold_tov = props.sold_tov;
    const tag = props.tag;
    // For addign '$' Sign to TOV value
    if (tag === 'won') {
      if (commit_tov === sold_tov) {
        let formattedValue = Number(commit_tov).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });
        return <TableData1C>{formattedValue}</TableData1C>;
      } else {
        let formattedValue1 = Number(sold_tov).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });
        let formattedValue2 = Number(commit_tov).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        });
        return (
          <TableData1C>
            {formattedValue1} (<s>{formattedValue2}</s>)
          </TableData1C>
        );
      }
    } else {
      let formattedValue = Number(commit_tov).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return <TableData1C>{formattedValue}</TableData1C>;
    }
  };
  TextCellRendererD.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const columnDefs = [
    {
      headerName: 'Commit',
      field: 'commit_status',
      sortable: false,
      filter: true,
      cellRenderer: 'commitCellRenderer',
      headerComponentParams: { showFilter: true, enableSorting: false },
      suppressMovable: true,
      width: 125,
    },
    {
      headerName: 'Status',
      field: 'tag',
      sortable: true,
      filter: true,
      cellRenderer: 'statusCellRenderer',
      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 120,
      suppressMovable: true,
    },
    {
      headerName: 'ID',
      field: 'ey_id',
      sortable: true,
      filter: true,
      cellRenderer: 'textCellRendererCBold',
      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 95,
      suppressMovable: true,
    },
    {
      headerName: 'Opportunity Name',
      field: 'opportunity_name',
      sortable: true,
      filter: true,
      cellRenderer: 'textCellRendererCBold', //opportunity_name
      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 200,
      comparator: OppsNameSorting,
      suppressMovable: true,
    },
    {
      headerName: 'Client',
      field: 'client_name',
      sortable: true,
      filter: true,
      cellRenderer: 'textCellRendererC',
      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 200,
      suppressMovable: true,
    },
    {
      headerName: 'Eff. Close Date',
      field: 'close_date',
      sortable: true,
      filter: 'agDateColumnFilter',
      filterParams: DateFiltering,
      cellRenderer: 'dateCellRenderer',
      cellRendererParams: params => {
        const month = params.data.ecd_month;
        const date = params.data.close_date;
        return {
          month,
          date,
        };
      },
      headerComponentParams: {
        showFilter: true,
        enableSorting: true,
        subText: TABLE_HEADER_SUBTEXT.DATE_FISCAL_MONTH,
      },
      width: 175,
      suppressMovable: true,
      comparator: DateSorting,
    },
    {
      headerName: 'AWD',
      field: 'awd',
      sortable: true,
      filter: 'agDateColumnFilter',
      filterParams: DateFiltering,
      cellRenderer: 'dateCellRenderer',
      cellRendererParams: params => {
        const month = params.data.awd_month;
        const date = params.data.awd;
        return {
          month,
          date,
        };
      },
      headerComponentParams: {
        showFilter: true,
        enableSorting: true,
        subText: TABLE_HEADER_SUBTEXT.DATE_FISCAL_MONTH,
      },
      width: 175,
      suppressMovable: true,
      comparator: DateSorting,
    },
    {
      headerName: 'TOV ($)',
      field: 'commit_tov',
      sortable: true,
      filter: true,
      cellRenderer: 'textCellRendererD',
      cellRendererParams: params => {
        const commit_tov = params.data.commit_tov;
        const sold_tov = params.data.sold_tov_eop;
        const tag = params.data.tag;
        return {
          commit_tov,
          sold_tov,
          tag,
        };
      },
      headerComponentParams: {
        showFilter: true,
        enableSorting: true,
        subText: TABLE_HEADER_SUBTEXT.ACTUAL_FORECASTED,
      },
      width: 220,
      suppressMovable: true,
      cellClass: 'cell-text-aligment',
    },
    {
      headerName: 'Stage',
      field: 'stage_name',
      sortable: false,
      filter: true,
      cellRenderer: 'textCellRendererC',
      headerComponentParams: { showFilter: true, enableSorting: false },
      width: 130,
      suppressMovable: true,
      // cellClass: 'cell-text-aligment'
    },
    {
      headerName: 'Account',
      field: 'account_name',
      sortable: true,
      filter: true,
      cellRenderer: 'textCellRendererC',
      headerComponentParams: { showFilter: true, enableSorting: true },
      width: 200,
      suppressMovable: true,
    },
  ];

  return (
    <PLPastTableContainer id="container">
      {isLoading && !opportunitiesLoaded ? (
        <div
          style={
            isMobile
              ? { position: 'fixed', top: '50%', left: '50%' }
              : { position: 'fixed', top: '50%', left: '35%' }
          }
        >
          <SpinnerLoader color="#155CB4" />
        </div>
      ) : (
        <>
          {rowData.length === 0 ? (
            <EmptyForcastContainer>
              <EmptyForcastText>
                You have missed the submission for this time period.
              </EmptyForcastText>
            </EmptyForcastContainer>
          ) : (
            <MotifTable
              // title="Title Bar"
              // domLayout="autoHeight"
              firstColumnBorderRight
              columnDefs={columnDefs}
              rowData={rowData}
              rowSelection="multiple"
              onGridReady={handleGridReady}
              suppressRowClickSelection
              suppressCellFocus
              suppressRowHoverHighlight={true}
              columnHoverHighlight={true}
              onSortChanged={() => gridApi.redrawRows()}
              components={{
                agColumnHeader: TableHeader, //for subtext add molecules/dcsp/components/tableHeader.jsx
                textCellRendererC: TextCellRendererC,
                statusCellRenderer: StatusCellRenderer,
                commitCellRenderer: CommitCellRenderer,
                textCellRendererCBold: TextCellRendererCBold,
                dateCellRenderer: DateCellRenderer,
                textCellRendererD: TextCellRendererD,
              }}
              alwaysShowHorizontalScroll={true}
              paginationPageSize={totalPageRows}
              pagination={true}
            />
          )}
        </>
      )}
    </PLPastTableContainer>
  );
};
export default PursuitLeaderPastTable;
